<template>
  <div
    v-if="needShow"
    :id="['container_' + id]"
    :class="['myContainer', isActive ? 'active' : '', 'container_id_' + id]"
    @click.self="clickContainer($event)"
    @drop.stop="drop2"
    @dragover.prevent
    @contextmenu.prevent="contextmenuHandle($event)"
    :style="Object.assign(bgStyle, zIndexControl)"
  >
    <!--    用于处理背景色+图片的情况-->
    <div v-if="request_prefix === 'bigScreen'" class="container_bg" @click.self="clickContainer"></div>
    <div
      v-if="isActive && request_prefix !== 'bigScreen' && !isLayoutStage && !isPhoneFullScreen"
      class="handle-btn-groups"
      ref="del"
    >
      <div>
        <span class="handle-icon-box" @mousedown.stop @click.stop="openMyContainerSet(id)"
          ><i class="icon icon-portal-card-view"></i><span class="icon-tips">设置</span></span
        >
        <span
          v-if="$store.state[this.request_prefix].page.children.length > 1"
          class="handle-icon-box"
          @mousedown.stop
          @click.stop="delMyContainer"
          ><i class="icon icon-portal-delete"></i><span class="icon-tips">删除</span></span
        >
      </div>
    </div>
    <VueDragResizable
      v-for="rect in children"
      :class="[
        $event.getIdsByStrId({
          container_id: id,
          rect_id: rect.rect_id,
          pageId
        }),
        (rect.shape === 'emptyLayoutComponent' || rect.shape === 'layoutComponent') && 'layoutComponent',
        topElementShow(rect) && 'top0',
        rect.active ? 'active' : ''
      ]"
      :key="'vdr' + rect.rect_id"
      :data-appId="rect.options.appId"
      :options="rect.options"
      :w="checkAndSetVal(rect.options, 'width', 'width', 20, { container_id: id, rect_id: rect.rect_id })"
      :h="checkAndSetVal(rect.options, 'height', 'height', 20, { container_id: id, rect_id: rect.rect_id })"
      :x="Number(checkAndSetVal(rect.options, 'left', 'left', 1, { container_id: id, rect_id: rect.rect_id }))"
      :y="Number(checkAndSetVal(rect.options, 'top', 'top', 1, { container_id: id, rect_id: rect.rect_id }))"
      :parentW="Number(getParentW)"
      :parentH="Number(getParentH)"
      :parent="true"
      :active="rect.active"
      :draggable="rect.draggable"
      :data-zxf-draggable = "rect.draggable"
      :resizable="checkResizable(rect)"
      :handles="checkHandles(rect)"
      :z="rect.zIndex"
      :rectId="rect.rect_id"
      :containerId="id"
      :snapWithAdsorbent="true"
      :shape="rect.shape"
      :swiperMode="rect.options.swiperMode"
      :zoom="zoom"
      :isShowModuleHandles="showModuleHandles"
      v-on:delElement="delElementEv"
      v-on:activated="activateEv(id, rect.rect_id, rect.shape)"
      v-on:deactivated="deactivateEv(id, rect.rect_id, rect.shape)"
      @swiperModeChange="handleSwiperMode($event, id, rect.rect_id)"
      v-on:dragging="draggingEv($event, id, rect.rect_id)"
      v-on:dragStop="dragStopEv($event, id, rect.rect_id)"
      v-on:dragStatuChange="moduleHandlesStatuChange($event)"
      v-on:resizing="changeSize($event, id, rect.rect_id, false, rect)"
      v-on:resizeStop="changeSize($event, id, rect.rect_id, true, rect)"
      @reRender="checkExcute"
      @refLineParams="getRefLineParams"
      @click="clickVdr"
      :myId="{ rect_id: rect.rect_id, container_id: id, elementInAutoLayoutId: rect.elementInAutoLayoutId, pageId }"
      :style="getSpecialStyle(rect)"
    >
      <div class="saveModule" v-show="rect.active && showModuleHandles && request_prefix !== 'bigScreen'">
        <span @click="openSaveModuleDialog">保存模块</span>
      </div>
      <div
        class="vdr_shade"
        :class="rect.options.leftType === '%' || rect.options.topType === '%' ? 'no-drag' : ''"
        v-if="
          !rect.active &&
          (ids.rect_id !== rect.rect_id || ids.container_id !== id) &&
          !$store.state.states.leftMenuDragStatus &&
          !isBigScreenPreview()
        "
      ></div>
      <component
        :zoom="zoom"
        :rect="rect"
        :active="rect.active"
        :options="rect.options"
        :parentOptions="parentElement"
        :rectheight="Number(rect.height)"
        :myid="{ rect_id: rect.rect_id, container_id: id, elementInAutoLayoutId: rect.elementInAutoLayoutId, pageId }"
        :class="['rect']"
        :style="bigScreenAnimateStyle(rect.options)"
        :oldAppId ="rect.appId"
        :is="rect.shape === 'emptyLayoutComponent' ? 'layoutComponent' : rect.shape"
      ></component>
    </VueDragResizable>
    <!--辅助线-->
    <span
      class="ref-line v-line"
      v-for="item in vLine"
      :key="'vLine' + item.id"
      v-show="item.display"
      :style="{
        left: item.position,
        top: item.origin,
        height: item.lineLength,
        borderColor: request_prefix === 'bigScreen' ? 'rgba(0, 224, 255, 1)' : 'rgba(209, 53, 212, 1)',
        color: request_prefix === 'bigScreen' ? 'rgba(0, 224, 255, 1)' : 'rgba(209, 53, 212, 1)'
      }"
    >
      <span class="distance-wrapper" :style="getVDistanceStyle(item)">{{
        item.display ? parseInt(item.lineLength.slice(0, -2) - item.h - item.ch) : ""
      }}</span>
    </span>
    <span
      class="ref-line h-line"
      v-for="item in hLine"
      :key="'hLine' + item.id"
      v-show="item.display"
      :style="{
        top: item.position,
        left: item.origin,
        width: item.lineLength,
        borderColor: request_prefix === 'bigScreen' ? 'rgba(0, 224, 255, 1)' : 'rgba(209, 53, 212, 1)',
        color: request_prefix === 'bigScreen' ? 'rgba(0, 224, 255, 1)' : 'rgba(209, 53, 212, 1)'
      }"
    >
      <span class="distance-wrapper" :style="getHDistanceStyle(item)">{{
        item.display ? parseInt(item.lineLength.slice(0, -2) - item.w - item.cw) : ""
      }}</span>
    </span>
    <!--辅助线END-->
    <div v-if="!isBigScreen && isActive && !isLayoutStage && !isPhoneFullScreen" class="container_btn_box">
      <div v-if="!isFooter">
        <cx-tooltip content="插入空白画布" class="item">
          <el-button class="container_btn" @click.stop="addContainer" circle icon="icon-portal-add_bold"></el-button>
        </cx-tooltip>
      </div>
      <div>
        <cx-tooltip content="拖拽画布高度" class="item">
          <div
            @dragstart.stop="changeHeightMouseDownEv"
            @drag.stop="changeHeightMouseEv"
            @dragend.stop="changeHeightMouseUpEv"
          >
            <el-button
              draggable="true"
              class="container_btn"
              :ref="'dragContainer' + id"
              :id="'dragContainer' + id"
              circle
              icon="icon-portal-up_down"
            >
            </el-button>
          </div>
        </cx-tooltip>
      </div>
      <div v-if="isCanMove && isCanUp">
        <cx-tooltip content="上移" class="item">
          <el-button
            class="container_btn content"
            @click.stop="changeContainerPosition('up')"
            circle
            icon="icon-portal-up_bold"
          ></el-button>
        </cx-tooltip>
      </div>
      <div v-if="isCanMove && isCanDown">
        <cx-tooltip content="下移" class="item">
          <el-button
            class="container_btn"
            @click.stop="changeContainerPosition('down')"
            circle
            icon="icon-portal-down_bold"
          ></el-button>
        </cx-tooltip>
      </div>
    </div>

    <!--辅助拖拽块-->
    <div class="boundingBox" :style="boundingBoxStyle"></div>

    <!-- 单元格 克隆状态下的遮罩 -->
    <div
      @click.stop
      v-if="$store.state.states.isClonePattern || this.$store.state.states.isOrderPattern"
      id="cloneShade"
    ></div>
    <!-- 单元格 克隆状态下的遮罩 end-->
  </div>
</template>

<script>
import VueDragResizable from "./publicComponent/vueDragRiseable/vue-drag-resizable.vue"
import {
  _throttle,
  encryption,
  getAllColsUidInLayoutComponent,
  handleFindLayoutComponentOptions,
  getAllElementsInColsInLayoutComponent,
  _debounce,
  smartMathMax
} from "../utils/index"
import { getFirstModuleEncId, getSyetemModuleJson } from "@/utils/initEv.js"
import { data_dictionary_map } from "root/static/dataDictionary"
import componentMixIn from "./stageComponentMixin.js"
import { primaryBigScreenGenerator as primarybigScreenGenerator } from "../store/modules/bigScreen/state"
import { primaryStageGenerator as primarystageGenerator } from "../store/modules/stage/state"
import { primaryAppStageGenerator as primaryappStageGenerator } from "../store/modules/appStage/state"
import { deepChangeUid, getCookie } from "utils"
import { LayoutGenerator } from "dependencies/emptyLayout/utils/layoutGenerator"
const mockData = { primarybigScreenGenerator, primaryappStageGenerator, primarystageGenerator }
import { CATEGORY_MODE } from "@/consts/index.js"
export default {
  name: "stage",
  mixins: [componentMixIn],
  components: {
    VueDragResizable
  },
  props: {
    index: {
      type: Number
    },
    id: {
      type: Number,
      default: 0
    },
    parentElement: {
      type: Object
    },
    stageType: {
      type: String,
      default: undefined
    },
    isBigScreen: {
      type: Boolean,
      default: false
    },
    zoom: {
      type: Number,
      default: 1
    },
    isActive: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 1920
    },
    height: {
      type: Number,
      default: 600
    },
    containerOptions: {
      type: Object
    },
    pageId: {
      type: String
    },
    scrollLeft: {
      type: Number
    },
    scrollTop: {
      type: Number
    },
    rulerThickness: {
      type: Number
    },
    contentWidth: {
      type: Number
    },
    children: { type: Array },
    appEditWidth: {
      type: Number
    }
  },
  data() {
    return {
      this2: this,
      dialogFormVisible3: false,
      saveModuleForm: {
        name: null,
        type: null
      },
      form: {
        name: null
      },
      formLabelWidth: "120px",
      dialogFormVisible: false,
      dialogFormVisible2: false,
      cacheDataTypes: [],
      restDataUrl: null,
      typeVal: null,
      initContainerH: null,
      containerBtnLock: null,
      containerData: {
        name: "基础容器",
        thumbnail: "http://117209pq.mh.chaoxing.com/assets/images/left_panel/icon-layout1.png",
        isActive: false
      },
      AllComponents: {
        type: "swiperBase",
        type: "swiperCard"
      },
      vLine: [],
      hLine: [],
      colsIdFromActiveRect: [],
      showModuleHandles: true,
      mounted: false,
      autoPlayAnimate: true,
      boundingBoxStyle: {
        width: 0,
        height: 0,
        top: 0,
        left: 0,
        display: "none"
      },
      dropStopTime: new Date().getTime()
    }
  },
  computed: {
    isLayout() {
      if (this.isPhoneFullScreen) {
        // 翻页模版不能设置为布局模式
        return false
      }
      return this.$store.state[this.request_prefix].page.pageLayoutType
    },
    needShow() {
      let isShow = true
      if (this.containerOptions && this.containerOptions.hasOwnProperty("isShow")) {
        isShow = this.containerOptions.isShow
      }
      return (
        typeof this.id === "number" &&
        typeof this.isActive === "boolean" &&
        typeof this.width === "number" &&
        typeof this.height === "number" &&
        Array.isArray(this.children) &&
        typeof this.containerOptions === "object" &&
        isShow
      )
    },
    isFooter() {
      // 页面的头和底 不能进行位置的交换
      let inDocument = this.containerOptions.inDocument
      if (inDocument && ["footer"].indexOf(inDocument) > -1) {
        return true
      }
      return false
    },
    isCanDown() {
      let isShowFooter = this.$store.state[this.request_prefix].page.isShowFooter
      if (this.index === this.$store.state[this.request_prefix].page.children.length - 2 && isShowFooter) {
        return false
      } else {
        return true
      }
    },
    isCanUp() {
      let isShowHeader = this.$store.state[this.request_prefix].page.isShowHeader
      if (this.index === 1 && isShowHeader) {
        return false
      } else {
        return true
      }
    },
    isCanMove() {
      // 页面的头和底 不能进行位置的交换
      if (!this.containerOptions) {
        return true
      }
      let inDocument = this.containerOptions.inDocument
      if (inDocument && ["header", "footer"].indexOf(inDocument) > -1) {
        return false
      }
      return true
    },
    isPhoneFullScreen() {
      return this.$store.state[this.request_prefix].page.isPhoneFullScreen
    },
    isLayoutStage() {
      return this.$store.state[this.request_prefix].page.stageType === "layOut"
    },
    bigScreenAnimateStyle() {
      return function (options) {
        if (this.request_prefix === "bigScreen") {
          return {}
        }
        return {
          // "animation-delay": options.animateSets.animateDelay * 1000 + "ms",
          // "animation-duration": options.animateSets.animateDuration * 1000 + "ms"
          // "animation-iteration-count": options.animateSets.animateTriggerNumType === "多次触发" ? "infinite" : "1",
        }
      }
    },
    getParentW() {
      if (this.stageType === undefined || this.stageType === "position") {
        return this.request_prefix === "appStage" ? this.appEditWidth : this.width
      } else {
        if (this.mounted) {
          return window.getComputedStyle(this.$el).getPropertyValue("width").slice(0, -2)
        } else {
          return this.request_prefix === "appStage" ? this.appEditWidth : this.width
        }
      }
    },
    getParentH() {
      if (this.isPhoneFullScreen) {
        return 762
      }
      if (this.stageType === undefined || this.stageType === "position") {
        return this.height
      } else {
        if (this.mounted) {
          return window.getComputedStyle(this.$el).getPropertyValue("height").slice(0, -2)
        } else {
          return this.height
        }
      }
    },
    ids() {
      return this.$store.state.states.activeID
    },
    topElementShow() {
      //判断上方有无标题并且显示
      return function (rect) {
        if (rect?.options?.hasOwnProperty("titleOptions")) {
          let elementOptions = rect.options.titleOptions[0].elementOptions
          let flag = true
          for (let i = 0; i < elementOptions.length; i++) {
            if (elementOptions[i].isShow) {
              flag = false
              break
            }
          }
          return flag
        }
        return true
      }
    },
    stageWidth() {
      if (this.request_prefix === "stage") {
        if (this.stageType === "position") {
          return this.width + "px"
        } else if (typeof this.stageType === "undefined") {
          // pc端编辑区域宽度 以1920作为全屏标准
          return "1920px"
        }
      } else {
        return "100%"
      }
    },
    stageHeight() {
      if (this.stageType === undefined || this.stageType === "position") {
        return this.height + "px"
      } else return "100%"
    },
    fixedPos() {
      let topOperationH =
        (document.getElementsByClassName("top_operation")[0] &&
          document.getElementsByClassName("top_operation")[0].offsetHeight) ||
        60
      let left = "unset",
        top = "unset",
        bottom = "unset",
        right = "unset",
        width = undefined,
        transform = "none",
        marginTop = "0px",
        marginBottom = "0px",
        marginLeft = "0px",
        marginRight = "0px",
        borderRadius = "0px"
      if (this.containerOptions && this.containerOptions.isFixed) {
        switch (this.containerOptions.positionType) {
          case "left top":
            top = topOperationH + "px"
            left = "0px"
            marginLeft = this.containerOptions.marginLeft + "px"
            marginTop = this.containerOptions.marginTop + "px"
            break
          case "center top":
            left = "50%"
            top = topOperationH + "px"
            transform = "translateX(-50%)"
            marginLeft = this.containerOptions.marginLeft + "px"
            marginTop = this.containerOptions.marginTop + "px"
            break
          case "right top":
            top = topOperationH + "px"
            right = "0px"
            marginRight = this.containerOptions.marginRight + "px"
            marginTop = this.containerOptions.marginTop + "px"
            break
          case "left center":
            left = "0px"
            top = "50%"
            transform = "translateY(-50%)"
            marginLeft = this.containerOptions.marginLeft + "px"
            marginTop = this.containerOptions.marginTop + "px"
            break
          case "center center":
            left = "50%"
            top = "50%"
            transform = "translate(-50%,-50%)"
            marginLeft = this.containerOptions.marginLeft + "px"
            marginTop = this.containerOptions.marginTop + "px"
            break
          case "right center":
            right = "0px"
            top = "50%"
            transform = "translateY(-50%)"
            marginRight = this.containerOptions.marginRight + "px"
            marginTop = this.containerOptions.marginTop + "px"
            break
          case "left bottom":
            left = "0px"
            bottom = "0px"
            marginLeft = this.containerOptions.marginLeft + "px"
            marginBottom = this.containerOptions.marginBottom + "px"
            break
          case "center bottom":
            bottom = "0px"
            left = "50%"
            transform = "translateX(-50%)"
            marginLeft = this.containerOptions.marginLeft + "px"
            marginBottom = this.containerOptions.marginBottom + "px"
            break
          case "right bottom":
            right = "0px"
            bottom = "0px"
            marginRight = this.containerOptions.marginRight + "px"
            marginBottom = this.containerOptions.marginBottom + "px"
            break
          default:
            top = topOperationH + "px"
            left = "0px"
            marginLeft = this.containerOptions.marginLeft + "px"
            marginTop = this.containerOptions.marginTop + "px"
        }
        switch (this.containerOptions.inDocument) {
          case "none":
            borderRadius =
              this.containerOptions.borderTopLeftRadius +
              "px " +
              this.containerOptions.borderTopRightRadius +
              "px " +
              this.containerOptions.borderBottomRightRadius +
              "px " +
              this.containerOptions.borderBottomLeftRadius +
              "px"
            break
          case "header": //头部
            let stagePosition = document.getElementById("vueRulerContainer").getBoundingClientRect()
            if (this.request_prefix === "appStage") {
              let innerStagePosition1 = document.getElementsByClassName("edit_stage_app")[0].getBoundingClientRect()
              left = innerStagePosition1.left - this.scrollLeft + "px"
              right = "unset"
              width = this.appEditWidth + "px"
              if (this.showRuler) {
                top = (stagePosition.top + this.rulerThickness) / this.zoom + "px"
              } else {
                top = stagePosition.top / this.zoom + "px"
              }
            } else {
              right = stagePosition.left + stagePosition.width + "px"
              if (this.showRuler) {
                top = (stagePosition.top + this.rulerThickness) / this.zoom + "px"
                left = (stagePosition.left + this.rulerThickness) / this.zoom - this.scrollLeft / this.zoom + "px"
              } else {
                top = stagePosition.top / this.zoom + "px"
                left = stagePosition.left / this.zoom - this.scrollLeft / this.zoom + "px"
              }
            }

            bottom = "unset"
            transform = "none"
            marginLeft = "0px"
            marginTop = "0px"
            marginRight = "0px"
            marginBottom = "0px"
            break
          case "footer": //底部
            let stagePosition1 = document.getElementById("vueRulerContainer").getBoundingClientRect()

            if (this.request_prefix === "appStage") {
              let innerStagePosition1 = document.getElementsByClassName("edit_stage_app")[0].getBoundingClientRect()
              left = innerStagePosition1.left - this.scrollLeft + "px"
              right = "unset"
              width = this.appEditWidth + "px"
              // 76为底部的工具栏高度 36  加上中间容器的 padding 20 底部工具栏取消了
              bottom = Math.ceil(20 / this.zoom) + 1 + "px"
            } else {
              if (this.showRuler) {
                left = (stagePosition1.left + this.rulerThickness - this.scrollLeft) / this.zoom + "px"
                // 76为底部的工具栏高度 36  加上中间容器的 padding 20 底部工具栏取消了
                bottom = Math.ceil(20 / this.zoom) + 1 + "px"
              } else {
                // 取消掉标尺的高度和宽度
                left = (stagePosition1.left - this.scrollLeft) / this.zoom + "px"
                bottom = Math.ceil / this.zoom + 1 + "px"
              }
              right = stagePosition1.left + stagePosition1.width + "px"
            }
            top = "unset"
            transform = "none"
            marginLeft = "0px"
            marginTop = "0px"
            marginRight = "0px"
            marginBottom = "0px"
            break
          default:
        }
      }
      return {
        left,
        right,
        top,
        bottom,
        width,
        transform,
        marginTop,
        marginRight,
        marginBottom,
        marginLeft,
        borderRadius
        // padding
      }
    },
    zIndexControl() {
      if (this.$store.state[this.request_prefix].page.stageType == "layOut") {
        return { zIndex: "2" }
      } else if (this.isPhoneFullScreen) {
        return {}
      }
    },
    getSpecialStyle() {
      return function (rect) {
        // 自动布局内部为定位,所以padding需要放在外层
        if (rect.shape === "cxAutoLayout") {
          let borderW = ""
          if (Array.isArray(rect.options.borderWidth)) {
            rect.options.borderWidth.forEach(item => [(borderW += ` ${item}px`)])
          } else {
            borderW += ` ${rect.options.borderWidth}px`
          }

          let padding = `${rect.options.padding}px`
          let boxShadow = `0 0 0 ${padding}   rgba(56, 154, 30, 0.4)  inset`
          if (!rect.options.textPaddingTypeFlag || rect.options.textPaddingTypeFlag === 2) {
            padding = ` ${rect.options.paddingTop}px  ${rect.options.paddingRight}px  ${rect.options.paddingBottom}px  ${rect.options.paddingLeft}px`
            boxShadow = `0 -${rect.options.paddingBottom}px 0 0   rgba(56, 154, 30, 0.4)  inset, -${rect.options.paddingRight}px 0 0 0    rgba(56, 154, 30, 0.4)   inset , ${rect.options.paddingLeft}px 0 0 0  rgba(56, 154, 30, 0.4)  inset, 0 ${rect.options.paddingTop}px 0 0   rgba(56, 154, 30, 0.4)  inset`
          }
          return {
            padding: padding,
            boxShadow: rect.active ? boxShadow : undefined,
            "border-top-left-radius": rect.options.borderTopLeftRadius + "px",
            "border-top-right-radius": rect.options.borderTopRightRadius + "px",
            "border-bottom-right-radius": rect.options.borderBottomRightRadius + "px",
            "border-bottom-left-radius": rect.options.borderBottomLeftRadius + "px",
            "border-style": rect.options.borderStyle,
            "border-color": rect.options.borderIsThemeColor ? this.themeColor : rect.options.borderColor,
            "border-width": borderW
          }
        }
      }
    },
    bgStyle() {
      if (!this.containerOptions) {
        return {}
      }
      let conatinerBg = {
        backgroundImage: "",
        height: this.stageHeight
      }
      let containerOptions = JSON.parse(JSON.stringify(this.containerOptions))
      if (!containerOptions.background || !Array.isArray(containerOptions.background)) {
        let defalutColor = this.request_prefix === "stage" ? "#fff" : "#00043A"
        containerOptions.background = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: false,
            color: containerOptions.bgColor || defalutColor
          }
        ]
      }
      containerOptions.background.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = conatinerBg.backgroundImage.length > 0 ? "," : ""
            conatinerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            conatinerBg.backgroundSize = bg.clipSize
            conatinerBg.backgroundPosition = bg.alignType
            conatinerBg.backgroundRepeat = bg.repeatType
            break
          case "color":
            // conatinerBg.backgroundColor = bg.isThemeColor
            //   ? this.$store.state[this.request_prefix].page.themeColor
            //   : bg.color
            conatinerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              // bg.data.stops.forEach(item => {
              //   tmp.push(item[0] + " " + item[1] * 100 + "%")
              // })
              let dot = conatinerBg.backgroundImage.length > 0 ? "," : ""
              // conatinerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              conatinerBg.backgroundImage += dot + this.$parseColor(bg)
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              // bg.data.stops.forEach(item => {
              //   radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              // })
              let dot = conatinerBg.backgroundImage.length > 0 ? "," : ""
              // conatinerBg.backgroundImage +=
              //   dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
              conatinerBg.backgroundImage += dot + this.$parseColor(bg)
            }
            break
          default:
        }
      })
      return { ...conatinerBg, ...this.styleObject }
    },
    styleObject() {
      if (!this.containerOptions) {
        return {}
      }
      if (this.request_prefix === "bigScreen") {
        return {}
      }

      let fixStyle
      if (this.containerOptions.isFixed) {
        fixStyle = {
          // opacity: this.containerOptions.opacity / 100,
          left: this.fixedPos.left,
          right: this.fixedPos.right,
          bottom: this.fixedPos.bottom,
          top: this.fixedPos.top,
          transform: this.fixedPos.transform,
          marginTop: this.fixedPos.marginTop,
          marginRight: this.fixedPos.marginRight,
          marginBottom: this.fixedPos.marginBottom,
          marginLeft: this.fixedPos.marginLeft,
          width: this.fixedPos.width || this.stageWidth,
          height: this.stageHeight,
          borderRadius: this.fixedPos.borderRadius
        }
      } else {
        fixStyle = {
          // opacity: this.containerOptions.opacity / 100,
          left: 0,
          right: 0,
          bottom: 0,
          top: 0,
          transform: this.isPhoneFullScreen ? "" : "none",
          marginTop: 0,
          marginRight: 0,
          marginBottom: 0,
          marginLeft: 0,
          borderRadius: 0,
          width: this.isPhoneFullScreen ? "100%" : this.stageWidth,
          height: this.isPhoneFullScreen ? "100%" : this.stageHeight
        }
      }
      return fixStyle
    },
    getVDistanceStyle() {
      return function (item) {
        if (!item.lineLength) {
          return
        }
        return {
          top: item.ch + (parseInt(item.lineLength) - item.h - item.ch) / 2 + "px"
        }
      }
    },
    getHDistanceStyle() {
      return function (item) {
        if (!item.lineLength) {
          return
        }
        return {
          left: item.cw + (parseInt(item.lineLength) - item.w - item.cw) / 2 + "px"
        }
      }
    },
    showRuler() {
      return this.$store.state.states.hasOwnProperty("showRuler") ? !this.$store.state.states.showRuler : false
    }
  },
  watch: {
    height(newVal, oldVal) {
      let containerEl = document.getElementById("container_" + this.id)
      if (this.stageType === undefined || this.stageType === "position") {
        containerEl.style.height = this.height + "px"
      } else {
        containerEl.style.height = "100%"
      }
    }
  },
  methods: {
    checkAndSetVal(opt, key, optname, val, ids) {
      let result = 0
      //兼容为NaN或没有的数值数据
      if (!opt.hasOwnProperty(key) || opt[key] !== opt[key] || opt[key] === null || opt[key] === undefined) {
        this.$changeOptionsEV(val, optname, false, null, ids)
        result = val
      } else {
        result = opt[key]
      }
      return result
    },
    // 处理自动布局组件设置尺寸为% 或者auto时候的手柄情况
    checkResizable(rect) {
      let widthType = rect.options.hasOwnProperty("widthType") ? rect.options.widthType : "px"
      let heightType = rect.options.hasOwnProperty("heightType") ? rect.options.heightType : "px"
      if (widthType !== "px" && heightType !== "px") {
        return false
      }
      return rect.resizable
    },
    checkHandles(rect) {
      if (!rect.resizable) {
        return []
      }
      let widthType = rect.options.hasOwnProperty("widthType") ? rect.options.widthType : "px"
      let heightType = rect.options.hasOwnProperty("heightType") ? rect.options.heightType : "px"
      if (widthType !== "px" && heightType !== "px") {
        return []
      }
      if (widthType === "px" && heightType !== "px") {
        return ["ml", "mr"]
      }
      if (widthType !== "px" && heightType === "px") {
        return ["tm", "bm"]
      }
      return ["tl", "tm", "tr", "mr", "br", "bm", "bl", "ml"]
    },
    clickVdr() {
      this.$emit("clickVdr")
    },
    checkExcute() {
      const ids = this.ids
      this.$confirm("确认重新绘制吗？", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        showClose: false,
        dangerouslyUseHTMLString: "<p>确认重新绘制吗？</p>",
        iconClass: `${this.request_prefix}_confirm_icon el-icon-warning`,
        cancelButtonClass: `${this.request_prefix}_confirm_cancel_button`,
        confirmButtonClass: `${this.request_prefix}_confirm_button`,
        customClass: `${this.request_prefix}_confirm custom_warning_dialog`
      })
        .then(() => {
          this.fixActiveId(ids)
          this.handleReRender()
        })
        .catch(err => {
          this.fixActiveId(ids)
          console.log(err)
        })
    },
    fixActiveId(ids) {
      const delActive = {
        container_id: ids.container_id,
        rect_id: ids.rect_id,
        uid: ids.uid,
        elementInLayoutId: ids.elementInLayoutId,
        option_name: "isActive",
        option_val: "delAllActive"
      }

      this.$store.commit("states/changeActiveID", { container_id: ids.container_id, rect_id: ids.rect_id })
      this.$store.dispatch(this.request_prefix + "/setActive", { container_id: ids.container_id, rect_id: ids.rect_id })
    },
    //重新绘制布局组件并把数据取出来
    handleReRender() {
      const rectAttr = this.getRectAttribute.call(this, this.ids)
      const useActiveIndex = rectAttr.options.categoryMode === CATEGORY_MODE.SAME ? 0 : rectAttr.options.activeIndex
      const pOptions = [rectAttr.options.rows[useActiveIndex]]
      const colsElementOptions = []
      this.getAllUidInLayoutComponent(pOptions).forEach(uid => {
        colsElementOptions.push(handleFindLayoutComponentOptions(pOptions, uid))
      })
      this.$emit("reRender", colsElementOptions)
      //将布局组件初始化为自由布局组件
      this.initLayoutComponent()
    },
    initLayoutComponent() {
      const emptyRowAttr = new LayoutGenerator({
        rows: [
          {
            height: "100%",
            cols: [
              {
                width: "100%",
                componentBoxOptions: {
                  bgColor: "rgba(255,255,255,0)"
                }
              }
            ]
          }
        ]
      }).rows[0]
      emptyRowAttr.cols[0].uid = this.$uuid.v1()
      this.$store.dispatch(this.request_prefix + "/initLayoutComponent", { ids: this.ids, rowData: emptyRowAttr })
    },
    getAllUidInLayoutComponent(pOptions) {
      return getAllColsUidInLayoutComponent(pOptions)
    },
    compress(base64String, w, quality) {
      var getMimeType = function (urlData) {
        var arr = urlData.split(",")
        var mime = arr[0].match(/:(.*?);/)[1]
        return mime
      }
      var newImage = new Image()
      var imgWidth, imgHeight

      var promise = new Promise(resolve => (newImage.onload = resolve))
      newImage.src = base64String
      return promise.then(() => {
        imgWidth = newImage.width
        imgHeight = newImage.height
        var canvas = document.createElement("canvas")
        var ctx = canvas.getContext("2d")
        if (Math.max(imgWidth, imgHeight) > w) {
          if (imgWidth > imgHeight) {
            canvas.width = w
            canvas.height = (w * imgHeight) / imgWidth
          } else {
            canvas.height = w
            canvas.width = (w * imgWidth) / imgHeight
          }
        } else {
          canvas.width = imgWidth
          canvas.height = imgHeight
        }
        ctx.clearRect(0, 0, canvas.width, canvas.height)
        ctx.drawImage(newImage, 0, 0, canvas.width, canvas.height)
        var base64 = canvas.toDataURL(getMimeType(base64String), quality)
        return base64
      })
    },
    moduleHandlesStatuChange($event) {
      this.showModuleHandles = !$event
    },

    initDataPageIds(newParam) {
      const dataPageIds = this.$store.state.states.getDataPageIds
      const param = { ...dataPageIds, ...newParam }
      if (!!newParam) {
        Object.keys(newParam).forEach(key => (param[key] === newParam[key] ? "" : param[key] === newParam[key]))
        this.$store.commit("states/updateDataPageIds", param)
      }
      return param
    },
    bindDataEv() {
      this.dialogFormVisible = true
    },
    handleParam() {
      const ids = this.ids
      let content = JSON.parse(JSON.stringify(this.getRectAttribute.call(this, ids)))
      content.active = false
      content = encryption(content, data_dictionary_map)
      const param = {
        c: content,
        a: "7C5C8F204A2F4171"
      }
      return param
    },
    openSaveModuleDialog() {
      this.dialogFormVisible3 = !this.dialogFormVisible3
    },
    addContainer() {
      const param = {
        container_data: new mockData["primary" + this.request_prefix + "Generator"](),
        id: this.id
      }
      this.$store.dispatch(this.request_prefix + "/insertContainer", JSON.parse(JSON.stringify(param)))
    },
    changeContainerPosition(type) {
      this.$store.dispatch(
        this.request_prefix + "/changeContainerPosition",
        JSON.parse(JSON.stringify({ type: type, id: this.id }))
      )
    },
    changeHeightMouseDownEv(ev) {
      this.initContainerH = ev.screenY
    },
    changeHeightMouseEv: _throttle(function (ev) {
      const endY = ev.screenY
      const newH = parseInt((endY - this.initContainerH) / this.zoom)
      this.initContainerH = endY
      const param = { container_id: this.id, type: "height", val: newH }
      this.$store.dispatch(this.request_prefix + "/changeContainerSize", JSON.parse(JSON.stringify(param)))
    }, 100),
    changeHeightMouseUpEv(ev) {
      const endY = ev.screenY
      const newH = endY - this.initContainerH
      this.initContainerH = endY
      const param = { container_id: this.id, type: "height", val: newH }
      this.$store.dispatch(this.request_prefix + "/changeContainerSize", JSON.parse(JSON.stringify(param)))
    },
    // 辅助线回调事件
    getRefLineParams(params) {
      const { vLine, hLine } = params
      let id = 0
      this.vLine = vLine.map(item => {
        item["id"] = ++id
        return item
      })
      this.hLine = hLine.map(item => {
        item["id"] = ++id
        return item
      })
    },

    handdleClearActive() {
      // this.clearAutoLayoutElementActive()
      this.clearSwiperElementActive() //处理轮播组件内组件的active
      this.hanleLayoutBacgroundColorClear() //处理布局组件背景色的active
      this.handleClearLeftMenuActive() //处理leftmenu的active
      if (this.$store.state.states.toolBarStatus) this.$store.commit("states/changeToolBarStatus", false)
      if (this.$store.state.states.alignHelperStatus) this.$store.commit("states/changeAlignHelperStatus", false)
      this.checkContainerActiveID() //处理ids，一定要放在最后！！！
    },
    handleClearLeftMenuActive() {
      const acId = this.$store.getters["menu/getActiveMenu"]
      if (acId) this.$store.dispatch("menu/unsetActive", { id: acId })
      if (this.$store.state.states.showLeftMenu) {
        this.$store.commit("states/changeShowLeftMenuStatus", false)
      }
    },
    checkContainerActiveID() {
      if (
        this.ids &&
        (this.ids.container_id !== this.id ||
          Object.keys(this.ids).some(k => k != "container_id" && this.ids[k] !== null))
      ) {
        this.$store.commit("states/changeActiveID", { container_id: this.id })
      }
    },
    clearSwiperElementActive() {
      const clearActive = {
        ...this.ids
      }
      for (const k in clearActive) {
        if (clearActive[k] === null) delete clearActive[k]
      }
      if (clearActive.hasOwnProperty("elementInSwiperId") && clearActive.elementInSwiperId !== null) {
        clearActive.elementInSwiperId = null
        this.$store.dispatch(this.request_prefix + "/changeElementInSwiperActive", clearActive)
      }
    },
    // clearAutoLayoutElementActive(elementOptions) {
    //   let container = this.$store.state[this.request_prefix].page.children.find(
    //     children => children.container_id === this.ids.container_id
    //   )
    //   if(!container){
    //     return
    //   }
    //   let rect = container.children.find(rect => rect.rect_id === this.ids.rect_id)
    //   let rectElement = rect && rect.options ? (rect.options.elementOptions ? rect.options.elementOptions : []) : []
    //   elementOptions = elementOptions || rectElement
    //   elementOptions.forEach(item => {
    //     let param = {
    //       ...this.ids,
    //       elementInAutoLayoutId: item.elementInAutoLayoutId,
    //       path: item.path
    //     }
    //     this.$store.dispatch(this.request_prefix + "/changeElementInAutoLayoutUnActive", param)
    //     if (item.elementOptions && item.elementOptions.length > 0) {
    //       this.clearAutoLayoutElementActive(item.elementOptions)
    //     }
    //   })
    // },
    hanleLayoutBacgroundColorClear() {
      let elementType = this.request_prefix === "bigScreen" ? "bigScreenContainer" : "container"
      this.$store.commit("states/changeElementType", elementType)
      if (this.$store.state.states.alignHelperStatus) this.$store.commit("states/changeAlignHelperStatus", false)
    },
    clickContainer: _throttle(function (e) {
      const time = new Date().getTime()
      // 拖拽完成100ms内点击容器不生效，防止误判
      if (this.isBigScreenPreview() || time - this.dropStopTime < 100) {
        return
      }
      this.$emit("clickContainer", e)
      const acId = this.$store.getters["menu/getActiveMenu"]
      // 选中当前容器
      const _stage = this.$store.state[this.request_prefix]
      if (!this.getAttrById(_stage, { container_id: this.id })?.isActive)
        this.$store.commit("states/changeActiveID", { container_id: this.id })
      this.$store.dispatch(this.request_prefix + "/setContainerActive", { container_id: this.id })
      this.$store.commit(
        "states/changeElementType",
        this.request_prefix.includes("bigScreen") ? "bigScreenContainer" : "container"
      )
      // 点击空白去掉逻辑文本的激活变量id
      this.$store.commit("states/changeLogicTextDynamicId", "")
      this.handdleClearActive()
    }, 100),
    contextmenuHandle(e) {
      if (e.button === 2) {
        this.$emit("contextmenu", e)
      }
    },
    resetRectAttrOpt(childItem, _attribute) {
      this.needHid = true
      let layoutUidMap = {}
      childItem.encId ? (_attribute.moduleId = childItem.encId) : ""
      childItem.typeId ? (_attribute.typeId = childItem.typeId) : ""
      // this.doAdd = true
      //鼠标移动处理
      if (this.request_prefix === "appStage" && _attribute.options.width > 414) {
        _attribute.options.width = 414
      }
      if (_attribute.shape === "layoutComponent" || "emptyLayoutComponent") {
        //递归修改uid 把menu里的默认uid（会导致cols的id值重复）修改为随机生成的uid
        layoutUidMap = deepChangeUid(_attribute)
      }
      _attribute.options.layoutUidMap = layoutUidMap
      return JSON.stringify(_attribute)
    },
    async drop2(e) {
      this.boundingBoxStyle = {
        top: 0,
        left: 0,
        display: "none"
      }
      if (this.isBigScreenPreview()) return
      if (e.target.parentNode.classList[0] !== "componentBox_after") {
        let rectAttr = e.dataTransfer.getData("rectAttribute")
        let childItemInfo = sessionStorage.getItem("childItemInfo")
        childItemInfo = JSON.parse(childItemInfo)
        if (childItemInfo.childItemName === "收藏") {
          rectAttr = JSON.parse(rectAttr)
          const _attribute = await getSyetemModuleJson(rectAttr.encId)
          rectAttr = JSON.stringify(_attribute)
        } else if (!rectAttr || rectAttr.length === 0 || rectAttr === "undefined" || !JSON.parse(rectAttr).shape) {
          if (childItemInfo.childItemTypeId) {
            let childItem = await getFirstModuleEncId.call(this, childItemInfo.childItemTypeId)
            let type = childItem.content.shape
            let attribute = childItem.content
            const _attribute = JSON.parse(JSON.stringify(attribute))
            rectAttr = this.resetRectAttrOpt(childItem, _attribute)
          } else {
            return
          }
        }
        rectAttr = JSON.parse(rectAttr)
        if (childItemInfo && childItemInfo.childItemTypeId) {
          rectAttr.options.componentTypeId = childItemInfo.childItemTypeId
          rectAttr.options.name = childItemInfo.childItemTitle ? childItemInfo.childItemTitle : childItemInfo.childItemName
          rectAttr.options.componentTypeName = childItemInfo.childItemTypeName
        }
        const [top, left] = this.getOffsetPosition(e)
        rectAttr.options.top = top - rectAttr.options.height / 2
        rectAttr.options.left = left - rectAttr.options.width / 2
        rectAttr.options.zIndex = 0
        const allRects = this.getAttrById.call(this, this.$store.state[this.request_prefix], {
          container_id: this.id
        }).children
        let _rect_id = -1
        if (allRects.length > 0) {
          _rect_id = smartMathMax(
            ...allRects.map(function (o) {
              return o.rect_id
            })
          )
        }
        let rect_id = _rect_id + 1
        this.$addHistory({
          type: "add",
          stateType: "addRect",
          payload: {
            container_id: this.id,
            rect_id
          }
        })

        // 如果当前数据中存在appId判断当前组件是否是系统保存好的样式
        if (rectAttr.options.myFetchParam?.appId || rectAttr.options.appId) {
          //更新appid
          const appId = rectAttr.options.appId ? rectAttr.options.appId : rectAttr.options.myFetchParam?.appId
          // 需要判断当前组件类型，如果是基于自由布局开发的搜索组件/导航菜单，需要特殊处理
          const isSearchComponent = rectAttr.options.pluginName?.includes("searchComponentPlugin")
          const isNavComponent = rectAttr.shape.toLowerCase().includes("nav")
          this.$styleToSaveModule("31CB73E03E24BBFF", "临时", appId, false, isSearchComponent, isNavComponent).then(
            res => {
              if (!!res.appId) {
                // 没有myfetchparam的组件 比如搜索组件 更新appId
                rectAttr.options.appId = res.appId
                // if (rectAttr?.options?.myFetchParam) {
                //   //如果拖入画布的组件有，myfetchparam，证明是自由布局或者轮播
                //   //则pageId,wfwfid,websiteId,更新为当前页面的值，防止老组件id不兼容
                //   const { pageId, wfwfid, websiteId } = this.$store.state.states.getDataPageIds
                //   rectAttr.options.appId = res.appId
                //   rectAttr.options.moduleId = res.moduleId
                //   rectAttr.options.myFetchParam.pageId = pageId
                //   rectAttr.options.myFetchParam.wfwfid = wfwfid
                //   rectAttr.options.myFetchParam.websiteId = websiteId
                //   rectAttr.options.myFetchParam.appId = res.appId
                // }
                const params = {
                  containerID: this.id,
                  data: rectAttr
                }
                this.$store.dispatch(this.request_prefix + "/addElement", params)
                this.activateEv(this.id, rect_id, rectAttr.shape)
              }
            }
          )
          //如果拖入画布的组件有，myfetchparam，证明是自由布局或者轮播
          //则pageId,wfwfid,websiteId,更新为当前页面的值，防止老组件id不兼容
          // if (rectAttr?.options?.myFetchParam) {
          //   const { pageId, wfwfid, websiteId } = this.$store.state.states.getDataPageIds
          //   if (rectAttr.options.myFetchParam.pageId) rectAttr.options.myFetchParam.pageId = pageId
          //   if (rectAttr.options.myFetchParam.wfwfid) rectAttr.options.myFetchParam.wfwfid = wfwfid
          //   if (rectAttr.options.myFetchParam.websiteId) rectAttr.options.myFetchParam.websiteId = websiteId
          // }
        } else {
          const params = {
            containerID: this.id,
            data: rectAttr
          }
          this.$store.dispatch(this.request_prefix + "/addElement", params)
          this.activateEv(this.id, rect_id, rectAttr.shape)
        }
        const lowerShape = rectAttr.shape.toLowerCase()
        //如果是自由布局组件 那就要检测自由布局组件内的组件是否有appid
        if (lowerShape.includes("layout")) {
          const allElementInLayout = getAllElementsInColsInLayoutComponent(rectAttr.options.rows)
          for (let uid in allElementInLayout) {
            const col = allElementInLayout[uid]
            col.elementInLayout &&
              col.elementInLayout.forEach(elementInLayout => {
                if (elementInLayout.appId) {
                  const { elementInLayoutId } = elementInLayout
                  this.$saveModule(
                    { container_id: this.ids.container_id, rect_id: rectAttr.rect_id, uid, elementInLayoutId },
                    "31CB73E03E24BBFF",
                    "临时",
                    false,
                    elementInLayout.appId
                  )
                }
              })
          }
        }
      }
      sessionStorage.removeItem("childItemInfo")
    },
    getOffsetPosition(e) {
      let top = Number(e.offsetY)
      let left = Number(e.offsetX)
      const path = [e.target]
      this.getParentNode(e.target, path)
      path.some(el => {
        let classList = el.classList
        if (classList[0] === "myContainer") {
          return true
        } else if ([].find.call(classList, it => it === "vdr")) {
          const parent = document.getElementById(`container_${this.id}`)
          const parentPosition = parent.getBoundingClientRect()
          const position = el.getBoundingClientRect()
          top += (position.top - parentPosition.top) / this.zoom
          left += (position.left - parentPosition.left) / this.zoom
        }
      })
      return [top, left]
    },
    getParentNode(e, res = []) {
      const parentNode = e.parentNode
      if (parentNode) {
        res.push(parentNode)
        this.getParentNode(parentNode, res)
      } else {
        return res
      }
    },
    dragoverEV(e) {},
    //删除element
    delElementEv(args) {
      this.$confirm("确认删除吗？", "", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        showClose: false,
        dangerouslyUseHTMLString: "<p>确认删除吗？</p>",
        iconClass: `${this.request_prefix}_confirm_icon el-icon-warning`,
        cancelButtonClass: `${this.request_prefix}_confirm_cancel_button`,
        confirmButtonClass: `${this.request_prefix}_confirm_button`,
        customClass: `${this.request_prefix}_confirm custom_warning_dialog`
      })
        .then(() => {
          //执行删除操作
          //获取所有键
          const keys = Object.keys(args)
          const ableIn = keys.every(item => {
            return item !== null
          })

          //判断是否每个键值都不为null
          if (keys.length === 2 && ableIn) {
            this.$store.commit(
              "states/changeElementType",
              this.request_prefix === "bigScreen" ? "bigScreenContainer" : "container"
            )
            this.$store.commit("states/changeActiveID", { container_id: this.ids.container_id })
            this.$store.dispatch(this.request_prefix + "/deleteElement", args)
          }
          this.$message({
            customClass: "bigScreen_msg_backGroud",
            duration: 3000,
            type: "success",
            message: "删除成功"
          })
        })
        .catch(() => {})
    },
    activateEv(container_id, rect_id, shape) {
      // isShade 是判断是否是上层的遮罩
      // 控制缓存组件的appid同步
      this.clearSwiperElementActive()
      const myAttr = this.getRectAttribute.call(this, { container_id: container_id, rect_id: rect_id })
      const myAppId = myAttr.appId
      if (myAppId) {
        const { moduleId, typeId } = this.getRectAttribute.call(this, { container_id: container_id, rect_id: rect_id })
        this.initDataPageIds({ moduleId, typeId, appId: myAppId.appId })
      }
      if (!this.$store.state.states.alignHelperStatus && !localStorage.getItem("multipleComponent")) {
        this.$store.dispatch(this.request_prefix + "/setActive", {
          container_id: container_id,
          rect_id: rect_id
        })
        this.$store.commit("states/changeElementType", shape)
        this.$store.commit("states/changeActiveID", {
          container_id: container_id,
          rect_id: rect_id
        })
        //    }
      } else {
        this.$store.commit(this.request_prefix + "/ENABLE_ACTIVE", {
          container_id: container_id,
          rect_id: rect_id
        })
        let newArr = JSON.parse(sessionStorage.getItem("tmpComponents")) || []
        if (localStorage.getItem("multipleComponent")) {
          newArr.push({
            container_id: container_id,
            rect_id: rect_id
          })
        }else{
          newArr=[{
            container_id: container_id,
            rect_id: rect_id
          }]
        }
        sessionStorage.setItem("tmpComponents", JSON.stringify(newArr))
      }
      if (container_id !== null && rect_id !== null && !shape.toLowerCase().includes("layoutComponent")) {
        // 放开了轮播图未激活时  在此激活的情况
        if (this.ids.container_id === container_id && this.ids.rect_id === rect_id) {
          return
        }
        let param = {
          container_id: container_id,
          rect_id: rect_id
        }
        this.$store.commit("states/changeActiveID", param)
        this.$store.commit("states/changeElementType", shape)
      }
    },
    deactivateEv(id, index, shape) {
      if (!this.$store.state.states.elementType) {
        this.$store.commit("states/changeElementType", null)
      }
      this.$store.dispatch(this.request_prefix + "/unsetActive", {
        container_id: id,
        rect_id: index
      })
    },
    dragStopEv(newRect, id, index) {
      const attr = this.getRectAttribute.call(this, this.ids)?.options || {}
      const [oL, oT] = [attr.left, attr.top]
      const [nL, nT] = [newRect.left, newRect.top]
      if (oL !== nL || oT !== nT) {
        this.dragExecute = false
        this.$store.commit("states/changeDragMode", true)
        this.dragExecute = true
        const componentIds = { container_id: id, rect_id: index }
        this.$store.commit("states/changeDragMode", false)
        const rulers = JSON.parse(localStorage.getItem("rulers"))
        if (Array.isArray(rulers)) {
          rulers.forEach(item => {
            if (item.type == "h") {
              if (Math.abs(newRect.top - item.site) < 10) {
                newRect.top = item.site
              }
              if (Math.abs(newRect.top + newRect.height - item.site) < 10) {
                newRect.top = item.site - newRect.height
              }
            }
            if (item.type == "v") {
              if (Math.abs(newRect.left - item.site) < 10) {
                newRect.left = item.site
              }
              if (Math.abs(newRect.left + newRect.width - item.site) < 10) {
                newRect.left = item.site - newRect.width
              }
            }
          })
        }
        this.$store.dispatch(this.request_prefix + "/setTop", {
          container_id: id,
          rect_id: index,
          top: newRect.top
        })
        this.$store.dispatch(this.request_prefix + "/setLeft", {
          container_id: id,
          rect_id: index,
          left: newRect.left
        })
        this.$store.commit("states/changeDraggingStatus", false)
      }
      this.dropStopTime = new Date().getTime()
    },

    draggingEv(newRect, id, index) {
      if (this.dragExecute) {
        if (!this.$store.state.states.dragStatus) this.$store.commit("states/changeDraggingStatus", true)
        const attr = this.getRectAttribute.call(this, this.ids).options
        const [oL, oT] = [attr.left, attr.top]
        const [nL, nT] = [newRect.left, newRect.top]
        if (oL !== nL || oT !== nT) {
          this.dragExecute = false
          this.$store.commit("states/changeDragMode", true)
        }
      }
    },
    handleSwiperMode(mode, id, rectId) {
      this.$changeOptionsEV(mode, "swiperMode", false, null, { container_id: id, rect_id: rectId })
    },
    changeSize: _throttle(function (newRect, id, index, isResizeStop, rect) {
      this.$store.commit(this.request_prefix + "/CHANGE_DRAGGABLE", { ...this.ids, rect_id: index, flag: false })
      if(!newRect.isQuickSite){
        this.$store.dispatch(this.request_prefix + "/setLeft", {
          container_id: id,
          rect_id: index,
          left: newRect.left
        })
        this.$store.dispatch(this.request_prefix + "/setTop", {
          container_id: id,
          rect_id: index,
          top: newRect.top
        })
      }

      if (rect.shape !== "cxAutoLayout" || (rect.shape === "cxAutoLayout" && rect.options.widthType === "px")) {
        this.$store.dispatch(this.request_prefix + "/setWidth", {
          container_id: id,
          rect_id: index,
          width: newRect.width
        })
      }
      if (rect.shape !== "cxAutoLayout" || (rect.shape === "cxAutoLayout" && rect.options.heightType === "px")) {
        this.$store.dispatch(this.request_prefix + "/setHeight", {
          container_id: id,
          rect_id: index,
          height: newRect.height
        })
      }

      if (isResizeStop) {
        this.$store.commit(this.request_prefix + "/CHANGE_DRAGGABLE", { ...this.ids,rect_id: index, flag: true })
        this.dropStopTime = new Date().getTime()
      }
    }, 10),
    openMyContainerSet(containerId) {
      if (this.isBigScreenPreview()) return
      //打开画布设置
      let activeID = {
        container_id: containerId
      }
      this.$store.commit("states/changeToolBarStatus", true)
      this.$store.commit("states/changeElementType", "container")
      this.ids.container_id !== containerId && this.$store.commit("states/changeActiveID", activeID)
    },
    delMyContainer() {
      // 删除画布
      this.$store.dispatch(this.request_prefix + "/deleteContainer", this.id)
    }
    // 将cookei值统一存储 避免每次需要都调用接口
    // async initDataCookie() {
    //   let myCookie = await getCookie("UID,current_page_id,website_id,website_fid,fid")
    //   this.$store.commit("states/updateMyCookie", myCookie)
    // }
  }
}
</script>

<style scoped>
.myContainer.fixed {
  position: fixed;
  z-index: 9999 !important;
}
.container_btn_box {
  position: absolute;
  bottom: -11px;
  width: 100%;
  height: 22px;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.container_btn_box div {
  z-index: 1000;
  display: inline-block;
  text-align: center;
}
.container_btn {
  color: #fff;
  padding: 0;
  font-size: 10px;
  background-color: var(--themeColor);
  border: none;
  margin: 0 9px;
  width: 22px;
  height: 22px;
  line-height: 22px;
  border-radius: 50%;
  text-align: center;
}
.container_btn:hover {
  background-color: var(--themeColorHover);
  color: #fff;
}
.filler {
  width: 100%;
  height: 100%;
  display: inline-block;
  position: absolute;
}

.round {
  border-radius: 50%;
}

.radious {
  border-radius: 10px;
}

.myContainer {
  position: relative;
  background-color: transparent;
}
.myContainer.active {
  border: 1px solid var(--themeColor);
}

.ref-line {
  position: absolute;
  border-top: 1px solid #00e0ff;
  z-index: 9999;
  font-size: 12px;
  font-weight: 700;
  text-align: center;
}

.v-line {
  width: 1px;
  border-left: 1px solid;
}

.h-line {
  height: 1px;
}
.saveModule {
  display: none;
  position: absolute;
  top: -42px;
  right: 0;
  width: 80px;
  text-align: center;
  font-size: 14px;
  color: var(--themeColor);
  line-height: 40px;
  border-radius: 0 4px 4px 0;
  height: 40px;
  background: #ffffff;
  border: 1px solid rgba(101, 101, 101, 0.2);
  border-left: none;
  cursor: pointer;
  z-index: 2;
}
.saveModule::before {
  position: absolute;
  content: "";
  top: 50%;
  left: 0;
  margin-top: -8px;
  height: 16px;
  width: 1px;
  background-color: #f2f2f2;
}
.save_module {
  width: 100%;
  padding: 10px 20px 0 20px;
  display: flex;
  flex-direction: row;
}
.form_name_stage {
  width: 10%;
}
.form_name_appstage {
  width: 22%;
}
.form_value {
  width: 40%;
}
</style>
<style lang="scss">
.myContainer > .handle-btn-groups {
  margin-top: 0;
  right: 0;
}
.myContainer.fixed > .handle-btn-groups {
  right: 0;
}
.handle-btn-groups > div {
  flex: 1;
}
.handle-btn-groups {
  border-right: none;
  border-radius: 4px 0 0 4px;
}
.handle-btn-groups {
  position: absolute;
  right: 0;
  text-align: right;
  margin-top: -38px;
  border-radius: 4px;
  padding: 0 2px;
  min-width: 40px;
  height: 36px;
  background: #ffffff;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  font-size: 12px;
  z-index: 1001;
  + .saveModule {
    right: 2px;
    z-index: 1001;
  }
  .handle-icon-box {
    position: relative;
    &:hover {
      .icon-tips {
        display: block;
      }
    }
    .icon-tips {
      position: absolute;
      display: none;
      background: rgba(0, 13, 34, 0.9);
      border-radius: 4px;
      padding: 8px 12px;
      font-size: 14px;
      top: -46px;
      left: 50%;
      transform: translateX(-50%);
      color: rgba(255, 255, 255, 0.8);
      z-index: 2;
      line-height: 20px;
      box-sizing: border-box;
      word-break: keep-all;
      &:after {
        position: absolute;
        content: "";
        bottom: -10px;
        left: 50%;
        margin-left: -5px;
        border-width: 5px;
        border-color: rgba(0, 13, 34, 0.9) transparent transparent;
        border-style: solid;
        z-index: 2;
      }
    }
  }
  .icon {
    display: inline-block;
    text-align: center;
    font-size: 20px;
    width: 28px;
    height: 28px;
    line-height: 28px;
    border-radius: 4px;
    color: #717989;
    &.active {
      color: #3d82f2;
      background: rgba(61, 130, 242, 0.1);
    }
  }

  i {
    margin-right: 4px;
    font-size: 16px;
  }

  div {
    cursor: pointer;
  }

  &>* {
    display: inline-block;
    vertical-align: middle;
  }
}
.container_bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
  background-color: transparent;
}
.other_content .vdr.active {
  z-index: 100 !important;
}
.vdr_shade {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background: transparent;
}
.vdr_shade:not(.no-drag) {
  cursor: default;
}
.boundingBox {
  position: absolute;
  background: rgba(61, 130, 242, 0.1);
  border: 1px solid rgba(61, 130, 242, 0.5);
  border-radius: 6px;
}
.distance-wrapper {
  position: absolute;
}
</style>
